<script>
import csrf from '../lib/csrf';

export default {
  data() {
    return {
      csrf: csrf.token
    };
  },
};
</script>

<template>
  <input
    type="hidden"
    name="authenticity_token"
    :value="csrf"
  >
</template>
